import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/gcstudent/aboutsection/AboutSection.css";
import aboutBg from "../../../assets/images/lib8.jpg"; // ← apni image ka path yahan daal dena

const HeroSection = ({ heroData }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="about-section"
      ref={sectionRef}
      style={{ backgroundImage: `url(${aboutBg})` }}
    >
      {/* Dark overlay over image */}
      <div className="about-overlay" />

      {/* Floating orbs */}
      <div className="orb orb-1" />
      <div className="orb orb-2" />
      <div className="orb orb-3" />

      <Container className="about-container">
        <Row className="justify-content-center align-items-center min-vh-section">
          <Col xs={12} md={10} lg={8} className="text-center">
            <div className={`about-content ${visible ? "animate-in" : ""}`}>
              <h2 className="about-title">
                {heroData.title}{" "}
                <span className="brand-highlight">{heroData.highLight}</span>
              </h2>
              <p className="about-subtitle">{heroData.subTitle}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;